import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 10%;
  border: 2px solid var(--color-primary);
  color: #fff;
  font-size: 12px;
  font-weight: normal;
  text-align: center;
  overflow: hidden;
  transition: 0.2s;
  img {
    height: 4rem;
  }
  div {
    align-self: flex-end;
    height: 50%;
    background-color: var(--color-primary);
    padding: 0.5rem;
  }
  :hover {
    transform: scale(1.1);
    box-shadow: 0 0 1rem #a6a6a6;
  }

  @media (max-width: 768px) {
    width: 80%;
    height: 100%;
    margin: auto;
  }
  @media (max-width: 600px) {
    width: 100%;
    height: 100%;
  }
`;
